import { DisabledTitle, Link } from "./styled";
import { LinkContent } from "./LinkContent";
import React from "react";
import { linkTrackId } from "../../../Utils/analyticsUtils";
export const StepLink = ({ active, complete, disableUpcomingSteps, disableNavigation, ariaLabel, onClick, onKeyDown, subTitle, title, mobileVariant, isMobileLayout, branding, }) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === "Enter" && onKeyDown) {
            onKeyDown();
        }
    };
    return (React.createElement(React.Fragment, null, (disableUpcomingSteps && !complete && !active) || disableNavigation ? (React.createElement(DisabledTitle, { tabIndex: 0, "aria-label": ariaLabel },
        React.createElement(LinkContent, { active: active, subTitle: subTitle, title: title, mobileVariant: mobileVariant, isMobileLayout: isMobileLayout, branding: branding }))) : (React.createElement(Link, { complete: complete, "aria-label": ariaLabel, onClick: handleClick, onKeyDown: handleKeyDown, "data-trackid": linkTrackId(title) },
        React.createElement(LinkContent, { active: active, subTitle: subTitle, title: title, mobileVariant: mobileVariant, isMobileLayout: isMobileLayout, branding: branding })))));
};
//# sourceMappingURL=index.js.map